import { useState } from 'react';
import { Priority } from '@a46-rss/shared';
import { useArticles } from '../hooks/useArticles';
import ArticleList from '../components/ArticleList';
import SearchBar from '../components/SearchBar';
import PriorityFilter from '../components/PriorityFilter';

export default function Home() {
  const [selectedPriorities, setSelectedPriorities] = useState<Priority[]>([1, 2, 3]);
  const [days, setDays] = useState(7);

  const fromDate = new Date();
  fromDate.setDate(fromDate.getDate() - days);

  const { articles, loading, totalCount } = useArticles({
    limit: 50,
    priority: selectedPriorities.length > 0 ? selectedPriorities : undefined,
    fromDate: fromDate.toISOString(),
  });

  return (
    <div className="space-y-6">
      {/* ヘッダー */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">最新の規制情報</h1>
          <p className="mt-1 text-sm text-gray-500">
            過去{days}日間の関連記事 ({totalCount}件)
          </p>
        </div>
      </div>

      {/* フィルター */}
      <div className="bg-white rounded-lg shadow-sm border p-4 space-y-4">
        {/* 検索 */}
        <SearchBar />

        <div className="flex flex-wrap items-center gap-6">
          {/* 優先度フィルター */}
          <div className="flex-1 min-w-[300px]">
            <PriorityFilter
              selected={selectedPriorities}
              onChange={setSelectedPriorities}
            />
          </div>

          {/* 期間フィルター */}
          <div>
            <span className="text-sm font-medium text-gray-700 mr-2">期間</span>
            <select
              value={days}
              onChange={(e) => setDays(Number(e.target.value))}
              className="px-3 py-1.5 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value={7}>過去7日</option>
              <option value={14}>過去14日</option>
              <option value={30}>過去30日</option>
              <option value={90}>過去90日</option>
            </select>
          </div>
        </div>
      </div>

      {/* 記事一覧 */}
      <ArticleList
        articles={articles}
        loading={loading}
        emptyMessage="条件に一致する記事がありません"
      />
    </div>
  );
}
